import { useEffect, useRef } from "react";

const DEFAULT_REFRESH_INTERVAL = 180000;
const DEFAULT_STAGGER_DELAY =  5000;
const DEFAULT_INITIAL_DELAY = 180000;

const shouldRefreshTab = (tab) => {
  if (!tab?.lastSearch) {
    return false;
  }
  if (tab.loading) {
    return false;
  }
  if (!tab.lastSearch.query) {
    return false;
  }
  if (tab.lastSearch.searchType === "backhaul") {
    return false;
  }
  return true;
};

export const useAutoRefreshTabs = ({
  enabled,
  tabs,
  refreshIntervalMs = DEFAULT_REFRESH_INTERVAL,
  staggerDelayMs = DEFAULT_STAGGER_DELAY,
  initialDelayMs = DEFAULT_INITIAL_DELAY,
  onRefresh,
}) => {
  const tabsRef = useRef(tabs);
  const refreshRef = useRef(onRefresh);

  useEffect(() => {
    tabsRef.current = tabs;
  }, [tabs]);

  useEffect(() => {
    refreshRef.current = onRefresh;
  }, [onRefresh]);

  useEffect(() => {
    if (!enabled || typeof window === "undefined") {
      return undefined;
    }
    let isCancelled = false;

    const triggerRefresh = () => {
      if (isCancelled) {
        return;
      }
      const currentTabs = Array.isArray(tabsRef.current)
        ? tabsRef.current
        : [];
      currentTabs.forEach((tab, index) => {
        if (!shouldRefreshTab(tab)) {
          return;
        }
        window.setTimeout(() => {
          if (!isCancelled) {
            refreshRef.current?.(tab);
          }
        }, index * staggerDelayMs);
      });
    };

    const safeInitialDelay = Math.max(
      0,
      Number.isFinite(initialDelayMs) ? initialDelayMs : refreshIntervalMs,
    );
    const startTimeoutId = window.setTimeout(triggerRefresh, safeInitialDelay);
    const intervalId = window.setInterval(triggerRefresh, refreshIntervalMs);

    return () => {
      isCancelled = true;
      window.clearTimeout(startTimeoutId);
      window.clearInterval(intervalId);
    };
  }, [enabled, refreshIntervalMs, staggerDelayMs, initialDelayMs]);
};


